import { cn } from '@/lib/utils';
import type { ContactImportPreviewStatus } from '../../utils/contact-import.utils';

const STATUS_CONFIG: Record<
  ContactImportPreviewStatus,
  { label: string; className: string; dotClassName: string }
> = {
  invalid: {
    label: 'Invalid',
    className: 'bg-red-50 text-red-800',
    dotClassName: 'bg-red-600',
  },
  valid: {
    label: 'Valid',
    className: 'bg-emerald-50 text-emerald-800',
    dotClassName: 'bg-emerald-600',
  },
};

type ImportContactsStatusBadgeProps = {
  status: ContactImportPreviewStatus;
};

export const ImportContactsStatusBadge = ({ status }: ImportContactsStatusBadgeProps) => {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        config.className
      )}
    >
      <span className={cn('size-1.5 rounded-full', config.dotClassName)} aria-hidden />
      {config.label}
    </span>
  );
};
